export default {
  goBackProfile: 'Профиль',
  addOwner: 'Добавить участника',
  sendOwners: 'Подтвердить | Подтвердить всех',
  ownerCountError: 'Количество дольщиков меньше минимально допустимого для данного типа собственности',
  ownerCompleteNameError: 'Обнаружены дольщики без имени или фамилии',
  oneOwnerCompleteError: 'Не заполнены данные у дольщика {name}',
  someOwnersCompleteError: 'Не заполнены данные у дольщиков: {names}',
  snilsControlSumError: 'Не сходится контрольная сумма СНИЛС',
  innControlSumError: 'Не сходится контрольная сумма ИНН',
  sendError: 'Не удалось отправить на проверку',
  confirmationSendModal: {
    title: 'Вы действительно хотите отправить информацию о дольщиках на проверку?',
    description: 'После отправки вы не сможете добавлять новых дольщиков или изменять данные',
    confirm: 'Принять',
    cancel: 'Отменить'
  },
  steps: {
    selectOwnership: 'Выбор типа\n собственности',
    transactionParticipant: 'Новый дольщик'
  },
  selectOwnership: {
    title: 'Выберите тип\n собственности',
    info: 'Выберите, как будете оформлять квартиру',
    confirmationChangeModal: {
      title: 'Вы действительно хотите изменить тип собственности?',
      description: 'Смена типа собственности приведёт к удалению всех внесённых вами дольщиков',
      confirm: 'Принять',
      cancel: 'Отменить'
    }
  },
  transactionParticipant: {
    title: 'Данные дольщика',
    confirmationChangeModal: {
      title: 'Вы действительно хотите изменить тип дольщика?',
      description: 'Смена типа дольщика приведёт к удалению всех внесённых данных этого дольщика, включая загруженные документы',
      confirm: 'Принять',
      cancel: 'Отменить'
    },
    confirmationDeleteModal: {
      title: 'Вы действительно хотите удалить дольщика?',
      description: 'Все заполненные данные и загруженные документы будут удалены безвозвратно',
      confirm: 'Принять',
      cancel: 'Отменить'
    },
    blockTitles: {
      statusParticipant: 'Статус дольщика',
      mainInfo: 'Основная информация'
    },
    labels: {
      selectStatus: 'Выберите статус',
      firstName: 'Имя',
      lastName: 'Фамилия',
      patronymicName: 'Отчество',
      selectBirthday: 'Выберите дату рождения'
    },
    deleteOwner: 'Сбросить | Удалить'
  },
  documents: {
    passport: {
      title: 'Паспортные данные',
      series: 'Серия',
      number: 'Номер',
      issuedByWhom: 'Кем выдан',
      dateOfIssue: 'Дата выдачи',
      dayOfIssue: 'День выдачи',
      monthOfIssue: 'Месяц выдачи',
      yearOfIssue: 'Год выдачи',
      divisionCode: 'Код подразделения',
      frontTitle: 'Основной разворот паспорта',
      reverseTitle: 'Страница с пропиской',
      successFront: 'Основной разворот загружен',
      successReverse: 'Прописка загружена'
    },
    snils: {
      title: 'СНИЛС',
      number: 'Номер СНИЛС',
      success: 'СНИЛС загружен'
    },
    inn: {
      title: 'Сертификат ИНН',
      number: 'Номер сертификата ИНН',
      success: 'ИНН загружен'
    },
    apostille: {
      title: 'Апостиль',
      number: 'Номер документа',
      success: 'Апостиль загружен'
    },
    passport_original: {
      title: 'Иностранный паспорт',
      number: 'Номер документа',
      success: 'Паспорт загружен'
    },
    spouses_notarial_consent: {
      title: 'Согласие супруга',
      success: 'Согласие супруга загружено'
    },
    marriage_contract: {
      title: 'Брачный договор',
      success: 'Брачный договор загружен'
    },
    child_representative_approval: {
      title: 'Согласие законного представителя',
      success: 'Согласие законного представителя загружено'
    },
    birth_certificate: {
      title: 'Свидетельство о рождении',
      success: 'Свидетельство о рождении загружено',
      series: 'Серия',
      number: 'Номер'
    }
  }
}
